import React from 'react';
import { Typography, CircularProgress } from '@material-ui/core';

import Modal from 'features/app/components/Modal';
import BaseBalanceDropdown from 'features/app/components/BaseBalanceDropdown';
import BaseButton from 'features/app/components/BaseButton';

import { usePartnerBalanceByUserQuery } from 'features/users/hooks/usePartnerBalanceByUserQuery';
import { useStyles } from 'features/users/components/ViewBalanceModal/styles';
import { BalanceCurrency } from 'features/app/ts/BalanceCurrency';

type ViewBalanceModalProps = {
  primaryButtonText?: string;
  onClose: () => void;
  errorText: string;
  title?: string;
  open: boolean;
  id: number;
};

export const ViewBalanceModal: React.FC<ViewBalanceModalProps> = ({
  primaryButtonText,
  errorText,
  onClose,
  title,
  open,
  id,
}) => {
  const { data, isLoading, error } = usePartnerBalanceByUserQuery(id);
  const classes = useStyles();
  const [activeCurrencyId, setActiveCurrencyId] = React.useState(data?.[0]?.id);

  const activeCurrency = React.useMemo(
    () => (activeCurrencyId ? data?.find(currency => currency.id === activeCurrencyId) : data?.[0]),
    [activeCurrencyId, data]
  );

  const handleCurrencyChange = React.useCallback(({ id }: BalanceCurrency) => {
    setActiveCurrencyId(id);
  }, []);

  return (
    <Modal
      onClose={onClose}
      title={title}
      open={open}
      paperClass={classes.paper}
      dialogContentClass={classes.dialogContent}
    >
      <div className={classes.balance}>
        {error ? (
          <Typography className={classes.error}>{errorText}</Typography>
        ) : isLoading ? (
          <CircularProgress size={50} />
        ) : (
          <BaseBalanceDropdown options={data} displayedBalance={activeCurrency} onChange={handleCurrencyChange} />
        )}
      </div>

      {primaryButtonText && (
        <BaseButton className={classes.button} labelClass={classes.buttonLabel} onClick={onClose}>
          {primaryButtonText}
        </BaseButton>
      )}
    </Modal>
  );
};
